import { render, staticRenderFns } from "./StepSecond.vue?vue&type=template&id=67f89b45&scoped=true&"
import script from "./StepSecond.vue?vue&type=script&lang=js&"
export * from "./StepSecond.vue?vue&type=script&lang=js&"
import style0 from "./StepSecond.vue?vue&type=style&index=0&id=67f89b45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f89b45",
  null
  
)

export default component.exports